import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

import {DEAL_FREEZE_ONBOARDING_EXPERIMENT} from '../components/DealFreezeOnboarding/constants'

/**
 * Whether the user is in the Deal Freeze onboarding variant.
 * @param isEligible - Caller preconditions, checked before the toggle so a
 * caller that cannot show the variant never allocates the user. Surfaces
 * shared with other journeys (sign-in, for one) MUST pass their own check
 * here rather than calling the toggle unguarded.
 * @returns True on the b side
 */
export const useIsDealFreezeOnboardingVariant = (
  isEligible = true
): boolean => {
  const toggle = useToggle()

  if (!isEligible) return false

  return toggle(DEAL_FREEZE_ONBOARDING_EXPERIMENT, false, true)
}
